/**
 * In-memory bearer-token cache. Apps wire their auth library (react-oidc-context,
 * raw oidc-client-ts, msal-react, …) to call `setToken` whenever the auth state
 * changes; HTTP layers (e.g. axios interceptors in @iplan/api-client) read via
 * `getToken` without a React dependency.
 *
 * The cache is intentionally process-local — token storage with persistence
 * is the auth library's job, not ours.
 */
class BearerTokenCache {
  private token: string | null = null;
  private listeners = new Set<(token: string | null) => void>();

  setToken(token: string | null): void {
    if (token === this.token) return;
    this.token = token;
    this.listeners.forEach((listener) => listener(token));
  }

  getToken(): string | null {
    return this.token;
  }

  clearToken(): void {
    this.setToken(null);
  }

  subscribe(listener: (token: string | null) => void): () => void {
    this.listeners.add(listener);
    return () => this.listeners.delete(listener);
  }
}

export const bearerTokenCache = new BearerTokenCache();
